import React, { useMemo, useState, useEffect, useCallback } from "react";
import ReactFlowRenderer from "./ReactFlowRenderer";

// Fonction utilitaire pour parser un scénario Gherkin en nodes/edges (exemple simple)
const parseGherkinToFlow = (testScenario) => {
  // Toujours obtenir une string
  let scenarioText = "";
  if (typeof testScenario === "string") {
    scenarioText = testScenario;
  } else if (testScenario && typeof testScenario.description === "string") {
    scenarioText = testScenario.description;
  } else if (testScenario && typeof testScenario.title === "string") {
    scenarioText = testScenario.title;
  } else {
    scenarioText = "";
  }

  const lines = scenarioText
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);
  let nodes = [];
  let edges = [];
  let prevId = null;
  let idx = 0;

  lines.forEach((line) => {
    const id = `node_${idx++}`;
    // Détecte le type d'étape pour le style
    let type = "default";
    if (/^Given/i.test(line)) type = "input";
    else if (/^When/i.test(line)) type = "process";
    else if (/^Then/i.test(line)) type = "output";

    nodes.push({
      id,
      data: { label: line },
      position: { x: idx * 240, y: 100 },
      draggable: true,
      style: {
        background:
          type === "input"
            ? "#fbbf24"
            : type === "process"
            ? "#60a5fa"
            : type === "output"
            ? "#34d399"
            : "#f3f4f6",
        color: "#111827",
        border: "2px solid #d1d5db",
        borderRadius: 8,
        fontWeight: 500,
        fontSize: 16,
        padding: 8,
        transition: "box-shadow 0.2s",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        cursor: "pointer",
      },
    });
    if (prevId) {
      edges.push({
        id: `e_${prevId}_${id}`,
        source: prevId,
        target: id,
        animated: true,
      });
    }
    prevId = id;
  });

  return { nodes, edges };
};

const TestFlowVisualizer = ({ testScenario }) => {
  const { nodes: initialNodes, edges } = useMemo(
    () => parseGherkinToFlow(testScenario),
    [testScenario]
  );

  // Stocke les nodes dans un state pour permettre le drag & drop
  const [nodes, setNodes] = useState(initialNodes);

  // Remet à jour les nodes si le scénario change
  useEffect(() => {
    setNodes(initialNodes);
  }, [initialNodes]);

  // Callback pour gérer le déplacement
  const onNodesChange = useCallback((changes) => {
    setNodes((nds) => ReactFlowRenderer.applyNodeChanges(changes, nds));
  }, []);

  if (!testScenario) {
    return (
      <div className="p-4 text-gray-500 text-center">
        Aucun scénario à visualiser
      </div>
    );
  }

  return (
    <div className="test-flow-container" style={{ minHeight: 400 }}>
      <ReactFlowRenderer
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
      />
    </div>
  );
};

export default TestFlowVisualizer;
